//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { DepartmentStoreLargeSVG } from './svg'

interface DepartmentStoreLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const DepartmentStoreLargeIcon: React.FC<DepartmentStoreLargeIconProps> = forwardRef<
  DepartmentStoreLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={DepartmentStoreLargeSVG}
    sx={sx}
  />
))
